export interface AdmInstance {
  Id: string;
  Url: string;
  Name: string;
  Ticket: string | null;
  SharedSecret: string;
}

export interface AdmAuthenticateResponse {
  Instances: AdmInstance[];
}

export interface AdmDataLink {
  Id: number;
  Name: string;
  DatabaseName: string;
}

export interface AdmDocumentMetadata {
  Id: number;
  DocTitle: string;
  DocFileExtension: string;
  UserName: string;
  ACloudGUID: string;
  DocDatePutin: string;
  DocumentType: string;
}

export interface AdmTempFileEntry {
  ClientFileKey: string;
  ServerFileKey: string;
}

export interface AdmFileUploadResponse {
  Identifiers: AdmTempFileEntry[];
}

export interface AdmTagValuePair {
  TagId: number;
  TagValue: string | number | boolean;
}

export interface AdmCreateDocumentRequest {
  ServerFileKey: string;
  Attributes: {
    DestinationFolderId: number;
    Title: string;
  };
  IndexingInfo: {
    DocTypeId: number;
    TagValues: AdmTagValuePair[];
  };
}

export interface AdmCreatedDocumentResponse {
  Id: number;
  Url: string;
}

export interface AdmDocumentContext {
  instanceUrl: string;
  dbName: string;
}

export const ADM_LINK_TYPE = "SLTransaction";
export const ADM_LINK_PRODUCT = "Access Dimensions";
export const ADM_DOC_TYPE_ID = 29;
export const ADM_FOLDER_ID = 4;

export const ADM_TAG_IDS = {
  DATABASE_NAME: 1,
  SALES_LEDGER_PRIMARY: 99,
  ACCOUNT_CODE: 3,
  ACCOUNT_NAME: 4,
  HEADER_REF: 67,
  TRANSACTION_DATE: 15,
  DESCRIPTION: 17,
  TRANSACTION_TYPE: 21,
} as const;

export const ADM_TAG_NAMES = {
  DATABASE_NAME: "Database Name",
  SALES_LEDGER_PRIMARY: "Sales Ledger Primary",
  ACCOUNT_CODE: "Account Code",
  ACCOUNT_NAME: "Account Name",
  HEADER_REF: "Header Ref",
  TRANSACTION_DATE: "Transaction Date",
  DESCRIPTION: "Description",
  TRANSACTION_TYPE: "Transaction Type",
} as const;
